module.exports = __webpack_public_path__ + "static/img/live_type02.10ecf7da.png";